import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import qrService from '../services/qrService';
import logo from '../styles/img/Logo.png'; // Adjust path as needed

class LoadEncryptionKeySection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showQrKey: true, // Always show the SecurePaper key
    };
    this.downloadKeyQRCode = this.downloadKeyQRCode.bind(this);
  }

  async componentDidMount() {
    if (!this.props.encryptionKey) {
      return;
    }
    const keyQrCanvas = await qrService.generateQrCodeWithLogo(this.keyCanvas, this.props.encryptionKey, logo);
    this.keyCanvas = keyQrCanvas;
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevProps.subject !== this.props.subject && this.keyCanvas) {
      const keyQrCanvas = await qrService.generateQrCodeWithLogo(this.keyCanvas, this.props.encryptionKey, logo, 240);
      this.keyCanvas = keyQrCanvas;
    }
  }

  downloadKeyQRCode() {
    if (this.keyCanvas) {
      // Create a temporary anchor element to trigger download
      const anchor = document.createElement('a');
      anchor.href = this.keyCanvas.toDataURL('image/png');
      // Create a user-friendly filename with subject and descriptive text
      const safeSubject = (this.props.subject || 'SecurePaper').replace(/[^a-z0-9]/gi, '-').substring(0, 30);
      anchor.download = `${safeSubject}-Encryption-Key-${moment().format('DD-MM-YYYY-HHmmss')}.png`;
      anchor.click();
      
      // Show success notification if available
      if (typeof this.showSuccessNotification === 'function') {
        this.showSuccessNotification("SecurePaper key downloaded!");
      }
    }
  }

  render() {
    return (
      <div className="text-center">
        <div>
          <canvas ref={(c) => { this.keyCanvas = c; }} />
        </div>
        <div className="mt-3">
          <button 
            onClick={this.downloadKeyQRCode} 
            className="btn btn-outline-primary btn-sm"
            title="Download SecurePaper Key Code"
          >
            <i className="fa fa-download" aria-hidden="true"></i> Download SecurePaper Key
          </button>
        </div>
      </div>
    );
  }
}

LoadEncryptionKeySection.propTypes = {
  encryptionKey: PropTypes.string,
  subject: PropTypes.string,
  isLoggedIn: PropTypes.bool,
};

export default LoadEncryptionKeySection;
